<template>
    <div class="outreach_base_title" @contextmenu.stop.prevent="tabRight($event,blockData)">
        <div class="m_title" :name='blockData.id' :enname='blockData.flowEnName'>
            <div class="title" @click="changeNav">
                {{blockData.title}}
            </div>
            <!--此处为标题名称-->
        </div>
        <div class="btn-title" v-if="blockData.floorType!='companyIntroduce' && blockData.floorType!='screenshow'" @contextmenu.stop.prevent="">
            <div class="return fl" @click="back()" v-if="blockData.floorType!='companyIntroduce'"></div>
            <!--二级标题开始-->
            <div class="second-title">{{blockData.subtitle}}</div>
            <!--此处为二级标题内容-->
            <!--二级标题结束-->
            <!--标题下方引导按钮 （如果不需要引导按钮 删除掉即可）-->
            <div class="guide-btn">
                <!--修改a标签里面的文字 修改标题下面按钮的引导文字-->
                <!-- <a class="blue" href="http://intelligent.520emv.com/Default1.do" target="_blank">进入{{titleByWin}}</a> -->
                <span class="blue"  @click="changeHref()">刷一刷</span>
                <!-- <span class="blue"  @click="changeHref()">体验</span> -->
            </div>
            <!--标题下方引导按钮 （如果不需要引导按钮 删除掉即可）-->
        </div>
    </div>
</template>

<script>
import Bus from '../../../bus.js'
export default {
    name:'tit',
    props:['blockData','src'],
    data(){
        return{}
    },
    computed:{
        titleByWin(){
            return window.document.title;
        },
        topTabFlag(){
            return this.$store.state.topTabFlag;
        }
    },
    methods:{
        tabRight(ev,item){
            //右键搜索功能所需参数
            window.$search = {item:item,area:'up',floor:this.blockData.id};
            window.$nodeId = '';
            window.$isBlock = this.blockData.flowEnName == 'meta-universe' ? 'yes' : '';
            window.$floorflowId = this.blockData;
            window.$changeFlowBlock = item.flowType;
            if (item.flowType == "flow") {
                window.$floorId = item.id;
            } else if (item.flowType == "block") {
                window.$blockId = item.id;
            }
            if (item.nodeId) {
                window.$nodeId = item.nodeId;
            }
            Bus.$emit('windowRight', ev, item ,this.blockData.flowEnName);
        },
        changeHref(){
            Bus.$emit('rightSlide',this.blockData.id);
        },
        changeNav(){
            this.$emit('refesh');
            // this.$backArr = [];
        },
        //返回上一级
        back(){
            this.$emit('refesh');
            return false;
            var item = this.$backArr.pop();
            if(this.src){
                this.$emit('clear');
            }else{
                if(this.topTabFlag){
                    //为true表示点击了
                    item = this.$backArr.pop();
                    this.$store.commit('setTopTabFlag',false);
                }
                if(!item){
                    this.$emit('refesh');
                    return false;
                }
                this.$emit('backFn',item.item,item.obj);
            }
        }
    }
}
</script>
<style scoped>
/*新标题 开始*/
.outreach_base_title .m_title{width:100%;height: 52px; margin: 0 auto;text-align: center;padding-top:32px;padding-bottom:2px;}
.outreach_base_title .m_title .title{line-height:24px;height: 52px;;text-indent: -7px;font-weight: normal;font-size: 24px;color: #333;background: url('~@/assets/image/images/m_title.png') no-repeat center bottom;}
/*新标题 结束*/

/*新标题下方引导按钮 开始*/
.outreach_base_title .btn-title{position: relative;padding-bottom:12px;min-height: 30px;}
.outreach_base_title .btn-title .guide-btn { position: absolute;right: 0px;top:0px;}
.outreach_base_title .btn-title .guide-btn span{display: inline-block;margin-right: 10px;font-size: 14px; line-height:30px;padding: 0 10px; text-align: center;border-radius: 3px;}
/* .outreach_base_title .btn-title .guide-btn span.blue{padding-left: 24px;color: #FFFfff;background: #2f8eed url( "../../../assets/image/images/wz_life_ty.png")
    no-repeat 5px center;} */
.outreach_base_title .btn-title .guide-btn span.blue{padding-left: 24px;color: #FFFfff;background: #2f8eed url( "../../../assets/image/images/refresh_14.png")
    no-repeat 5px center;}
.outreach_base_title .btn-title .guide-btn span.green{background: #12bca6;color: #FFFfff;}
.outreach_base_title .btn-title .guide-btn span:hover{filter: brightness(1.1);-webkit-filter: brightness(1.1);cursor: pointer;}
.outreach_base_title .btn-title .guide-btn span:last-of-type{margin-right: 0;}
.outreach_base_title .btn-title .second-title{overflow: hidden;text-overflow: ellipsis;white-space: nowrap; word-break:break-all;word-wrap:break-word;width: 650px;margin: 0 auto;line-height:30px; text-align: center; font-size: 14px; color: #797979; }
/*新标题下方引导按钮 结束*/

.outreach_base_title .btn-title .return{height:30px;width: 30px; background:url('~@/assets/image/images/icons/td_back_icon.png') no-repeat 0 4px; cursor: pointer;}

.outreach_base_title .btn-title .back-btn{position: absolute;left: 0;top: 0;}
.outreach_base_title .btn-title .back-btn .btn.disable{background-color: #eeeeee;}
.outreach_base_title .btn-title .back-btn .btn{display: inline-block;background: #2f8eed;color: #FFFfff;font-size: 14px;line-height: 30px;padding: 0 10px;text-align: center;border-radius: 3px;}
@media screen and (min-width:426px) and (max-width: 768px) { 
    /* .outreach_base_title .btn-title{margin:0 10px;} */
    .outreach_base_title .m_title .title{font-size:18px;}
    .outreach_base_title .btn-title .guide-btn a{font-size:12px;}
    .outreach_base_title .m_title{margin-top:18px;}
}
</style>


// WEBPACK FOOTER //
// src/components/floorBlock/control/tit.vue